export const currentNavigation = { isColdLoad: false, startedAt: 0, mountedAt: 0, routerResolvedAt: 0 };

export function noteNavigation(from: { matched: unknown[] }): void {
  currentNavigation.isColdLoad = from.matched.length === 0;
  currentNavigation.startedAt = currentNavigation.isColdLoad ? 0 : performance.now();
  currentNavigation.routerResolvedAt = 0;
}
